export default __webpack_public_path__ + "b1bdbb88309f453e4301ffa318ef9327.png";